import React, { useEffect, useRef } from 'react';
import Silk from '../Silk';
import { openWhatsAppChat } from '../WhatsAppFloat';

const Hero: React.FC = () => {
  const heroRef = useRef<HTMLElement>(null);
  const contentRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleScroll = () => {
      if (!heroRef.current || !contentRef.current) return;
      
      const scrolled = window.pageYOffset;
      const heroHeight = heroRef.current.offsetHeight;
      
      if (scrolled < heroHeight) {
        // Parallax effect untuk content
        const parallaxValue = scrolled * 0.5;
        contentRef.current.style.transform = `translateY(${parallaxValue}px)`;
        contentRef.current.style.opacity = String(1 - scrolled / 700);
        
        // Parallax effect untuk background
        const background = heroRef.current.querySelector('.hero-background');
        if (background) {
          (background as HTMLElement).style.transform = `translateY(${scrolled * 0.3}px)`;
        }
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      <style>{`
        .hero {
          min-height: 100vh;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          padding: 140px 48px 100px;
          text-align: center;
          position: relative;
          overflow: hidden;
          /* Hero menggunakan tema dark sendiri */
          --bg: #0a1628;
          --text: #ffffff;
          --muted: rgba(255, 255, 255, 0.7);
          --muted-2: rgba(255, 255, 255, 0.6);
          --border: rgba(255, 255, 255, 0.08);
          --border-strong: rgba(255, 255, 255, 0.12);
          --card: rgba(255, 255, 255, 0.03);
          --card-2: rgba(255, 255, 255, 0.02);
          --chip: rgba(255, 255, 255, 0.08);
          --accent: #ffffff;
          --accent-contrast: #0a1628;
          background: var(--bg);
          color: var(--text);
        }

        .hero-background {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          z-index: 0;
          opacity: 0.4;
        }

        .hero-content {
          position: relative;
          z-index: 1;
          width: 100%;
          transition: transform 0.1s ease-out, opacity 0.1s ease-out;
        }

        .hero-title {
          font-size: clamp(36px, 7vw, 100px);
          font-weight: 700;
          line-height: 0.95;
          letter-spacing: -0.04em;
          margin-bottom: 80px;
          animation: fadeInUp 1s ease-out;
        }

        .hero-title .line {
          display: block;
        }

        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(40px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .cta-button {
          display: inline-flex;
          align-items: center;
          gap: 12px;
          background: var(--accent, #ffffff);
          color: var(--accent-contrast, #0f0f0f);
          padding: 18px 36px;
          border-radius: 50px;
          text-decoration: none;
          font-weight: 600;
          font-size: 16px;
          transition: all 0.3s;
          border: 2px solid var(--accent, #ffffff);
        }

        .cta-button:hover {
          background: transparent;
          color: var(--text, #ffffff);
          transform: scale(1.05);
        }

        @media (max-width: 768px) {
          .hero {
            padding: 120px 24px 100px;
          }
        }
      `}</style>
      <section className="hero" ref={heroRef}>
        <div className="hero-background">
          <Silk
            speed={5}
            scale={1}
            color="#3B82F6"
            noiseIntensity={1.5}
            rotation={0}
          />
        </div>
        <div className="hero-content" ref={contentRef}>
          <h1 className="hero-title">
            <span className="line">Uidesk Omnichannel</span>
            <span className="line">Best Way to Solve Your Problems</span>
          </h1>
          <div style={{ marginTop: '24px', opacity: 0.9, fontSize: '18px' }}>
            Solusi CRM omnichannel terdepan untuk transformasi digital bisnis Anda.
          </div>
          <div style={{ marginTop: '40px' }}>
            <button
              type="button"
              className="cta-button"
              onClick={openWhatsAppChat}
            >
              Hubungi Kami
            </button>
          </div>
        </div>
      </section>
    </>
  );
};

export default Hero;

